import React from 'react';
import '../page/inquiry.css';

class InquiryImageModal extends React.Component {
    imageUrl = null; // 로컬 파일 Blob URL 저장

    componentDidUpdate(prevProps) {
        if (prevProps.file !== this.props.file || prevProps.show !== this.props.show) {
            this.revokeImageUrl(); // 이전 URL 해제

            const { file } = this.props;

            if (this.props.show && file && file.file) {
                // 문의 생성 시 로컬 파일을 사용하는 경우
                this.imageUrl = URL.createObjectURL(file.file);
                this.forceUpdate();
            } else if (this.props.show && file && file.fileUrl) {
            }
        } else if (prevProps.show === true && this.props.show === false) {
            this.revokeImageUrl(); // 모달 닫힐 때 URL 해제
        }
    }

    componentWillUnmount() {
        this.revokeImageUrl();
    }

    revokeImageUrl = () => {
        if (this.imageUrl) {
            URL.revokeObjectURL(this.imageUrl);
            this.imageUrl = null;
        }
    };

    render() {
        const { show, file, onClose, showDownload, downloadFile, order, isUserFile } = this.props;

        if (!show || !file) {
            return null;
        }

        const isImage = /\.(jpe?g|png|gif|bmp)$/i.test(file.name || file.filename);
        if (!isImage) return null;

        const currentImageUrl = this.imageUrl || file.fileUrl;

        if (!currentImageUrl) {
            return null;
        }

        return (
            <div
                className="inquiry-modal-backdrop"
                onClick={onClose}
            >
                <div
                    className="modal-dialog inquiry-modal-dialog"
                    onClick={e => e.stopPropagation()}
                >
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">{file.name || file.filename}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onClose}
                            ></button>
                        </div>

                        <div
                            className="modal-body inquiry-modal-body-scroll text-center"
                        >
                            <img
                                src={currentImageUrl}
                                alt={file.name || file.filename}
                                style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                            />
                        </div>

                        <div className="modal-footer justify-content-center">

                            {/* 다운로드 버튼은 문의 생성 시에도 항상 표시 (로컬 파일 다운로드) */}
                            {showDownload && (
                                <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={() => downloadFile(file.filename, order, isUserFile)}
                                >
                                    다운로드
                                </button>
                            )}

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InquiryImageModal;